import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Duration, endOfISOWeek, intervalToDuration } from 'date-fns';

import ContentContainer from '../../common/ContentContainer';
import BlockHeader from '../../common/BlockHeader';

import { ReactComponent as LeaderboardIcon } from '../../../assets/clan/season_leaderboard.svg';
import { useDataState } from '../../../providers/DataProvider.hooks';
import { getSuffix } from '../../../utils/helpers';

export const CurrentSeasonStats = () => {
    const { seasonNumber, seasonName } = useDataState();
    const [timeLast, setTimeLast] = useState<Duration | null>(null);

    useEffect(() => {
        const interval = setInterval(() => {
            const localTimezoneOffset = new Date().getTimezoneOffset();
            const localTimezoneOffsetMs = localTimezoneOffset * 60 * 1000;
            const gmtTimeMs = new Date().getTime() + localTimezoneOffsetMs;
            const gmtDate = new Date(gmtTimeMs);
            const endDate = endOfISOWeek(Date.now());
            const interval = intervalToDuration({
                start: gmtDate,
                end: endDate,
            });
            setTimeLast(interval);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <ContentContainer colorBg>
            <Box
                display={'flex'}
                justifyContent={'space-between'}
                sx={{
                    paddingTop: '80px',
                    marginBottom: '20px',
                    borderTop: '1px solid #D8DFE5',
                }}
            >
                <BlockHeader fontSize={'48px'} text="Current season clan stats"></BlockHeader>
            </Box>
            <Box
                sx={{
                    borderRadius: '20px',
                    backgroundColor: '#fff',
                    display: 'flex',
                    padding: '30px',
                    marginBottom: '60px',
                    alignItems: 'center',
                }}
            >
                <Box minWidth={88}>
                    <LeaderboardIcon></LeaderboardIcon>
                </Box>
                <Box
                    sx={{
                        margin: '0 20px',
                    }}
                >
                    <Typography
                        sx={{
                            color: '#0F0E0E',
                            fontFamily: 'AvenirNext600',
                            fontSize: '20px',
                        }}
                    >
                        {seasonName} season
                    </Typography>
                    <Typography
                        sx={{
                            color: '#9298A1',
                            fontFamily: 'AvenirNext400',
                            fontSize: '16px',
                        }}
                    >
                        The {getSuffix(seasonNumber)} season of Clan Tournaments is now live! Time's ticking, so ramp up
                        your stats because the championship results will be tallied up before you know it. Jump in and
                        make your mark before it's too late!
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        gap: '10px',
                        '& div': {
                            width: '99px',
                            height: '88px',
                            borderRadius: '15px',
                            border: '1px solid #D8DFE5',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        },
                        '& p:first-of-type': {
                            color: '#0F0E0E',
                            fontFamily: 'AvenirNext600',
                            fontSize: '20px',
                        },
                        '& p:last-of-type': {
                            color: '#9298A1',
                            fontFamily: 'AvenirNext400',
                            fontSize: '14px',
                        },
                    }}
                >
                    <Box>
                        <Typography>{timeLast?.days}</Typography>
                        <Typography>days</Typography>
                    </Box>
                    <Box>
                        <Typography>{timeLast?.hours}</Typography>
                        <Typography>hours</Typography>
                    </Box>
                    <Box>
                        <Typography>{timeLast?.minutes}</Typography>
                        <Typography>minutes</Typography>
                    </Box>
                    <Box>
                        <Typography>{timeLast?.seconds}</Typography>
                        <Typography>seconds</Typography>
                    </Box>
                </Box>
            </Box>
        </ContentContainer>
    );
};
